<script lang="ts">
    import { getContext, onMount } from "svelte";
    import moment from "moment";
    import { loader, swClient, toast, user } from "../stores";
    import type {
        AttrsOne,
        Campaign,
        CampaignTypeValue,
        CreateCampaignIn,
        CreateDocumentIn,
        CreateMilestoneIn, CreatePageIn,
    } from "../model";
    import { GetCampaignTypeByName, Types } from "../model";

    const { close } = getContext("simple-modal");

    let operation: {
        code: { value: string; error: string[] };
        name: { value: string; error: string[] };
        startDate: { value: string; error: string[] };
        endDate: { value: string; error: string[] };
        displayDate: { value: string; error: string[] };
        nbDocument: { value: number; error: string[] };
        typeCampaign: { value: CampaignTypeValue; error: string[] };
        centrale: { value: string; error: string[] };
        shop: { value: string; error: string[] };
        show_paf: { value: boolean; error: string[] };
        is_paf: { value: boolean; error: string[] };
    } = {
        code: { value: "", error: [] },
        name: { value: "", error: [] },
        startDate: { value: "", error: [] },
        endDate: { value: "", error: [] },
        displayDate: { value: "", error: [] },
        nbDocument: { value: 1, error: [] },
        typeCampaign: { value: "Nationale", error: [] },
        centrale: { value: "", error: [] },
        shop: { value: "", error: [] },
        show_paf: { value: true, error: [] },
        is_paf: { value: false, error: [] },
    };
    let formMode: "write" | "read" | "end-success" | "end-error" = "write";
    let campaigns: Campaign[] = [];

    onMount(async () => {});

    /**
     * check dataForm, if all valid, active the read mode for validate
     */
    function onCreate() {
        const processId = $loader.show("Vérification en cours");
        checkForm().then((valid) => {
            if (valid) {
                formMode = "read";
            }
            $loader.hide(processId);
        });
    }

    /**
     * close the modal
     */
    function onClose() {
        close();
    }

    function onCloseToast(form: string) {
        if (form == "end-success") {
            $toast.success("L'opération a été créée avec succès.");
        } else if (form == "end-error") {
            $toast.error(
                "Un problème est survenu lors de la création de l'opération."
            );
        }
        onClose();
    }

    /**
     * make request to create a new operation to SW
     */
    function onValid() {
        const mainProcessId = $loader.show("Création de l'opération en cours");

        // check again if operation code don't exist
        const checkProcessId = $loader.show("Vérification du code opération");
        isOperationCodeExist(operation.code.value)
            .then((exist) => {
                $loader.hide(checkProcessId);
                if (!exist) {
                    if (!operation.show_paf.value && operation.is_paf.value) {
                        operation.is_paf.value = false;
                    }

                    // create the campaign
                    const attrs: AttrsOne[] = [
                        {
                            key: Types.campaign.attrs.code,
                            value: operation.code.value,
                        },
                        {
                            key: Types.campaign.attrs.show_paf,
                            value: operation.show_paf.value.toString(),
                        },
                        {
                            key: Types.campaign.attrs.is_paf,
                            value: operation.is_paf.value.toString(),
                        },
                        {
                            key: Types.campaign.attrs.updated_date,
                            value: new Date().toISOString(),
                        },
                    ];
                    if (operation.typeCampaign.value === "Magasin") {
                        attrs.push({
                            key: "shop",
                            value: operation.shop.value,
                        });
                    }
                    const newCampaign: CreateCampaignIn = {
                        name: operation.name.value,
                        attrs: attrs,
                        type_uid: GetCampaignTypeByName(
                            operation.typeCampaign.value
                        ).uid,
                    };
                    const campaignProcessId = $loader.show(
                        "Requête de l'opération"
                    );
                    $swClient
                        .createCampaign(newCampaign)
                        .then(async (campaign) => {
                            if (campaign.uid !== "") {
                                const milestonesProcessId = $loader.show(
                                    "Requête des dates de l'opération"
                                );
                                $loader.hide(campaignProcessId);
                                // create milestones date
                                const displayDateML: CreateMilestoneIn = {
                                    name: Types.campaign.milestones
                                        .display_date,
                                    date: new Date(
                                        operation.displayDate.value
                                    ).toISOString(),
                                };
                                const startDateML: CreateMilestoneIn = {
                                    name: Types.campaign.milestones.start_date,
                                    date: new Date(
                                        operation.startDate.value
                                    ).toISOString(),
                                };
                                const endDateML: CreateMilestoneIn = {
                                    name: Types.campaign.milestones.end_date,
                                    date: new Date(
                                        operation.endDate.value
                                    ).toISOString(),
                                };
                                const resDisplay =
                                    await $swClient.createMilestonesByCampaign(
                                        campaign.uid,
                                        displayDateML
                                    );
                                const resStart =
                                    await $swClient.createMilestonesByCampaign(
                                        campaign.uid,
                                        startDateML
                                    );
                                const resEnd =
                                    await $swClient.createMilestonesByCampaign(
                                        campaign.uid,
                                        endDateML
                                    );

                                if (
                                    resDisplay.uid !== "" &&
                                    resStart.uid !== "" &&
                                    resEnd.uid !== ""
                                ) {
                                    const documentsProcessId = $loader.show(
                                        "Requête des versions de l'opération"
                                    );
                                    $loader.hide(milestonesProcessId);
                                    // create all documents needed
                                    for (
                                        let i = 1;
                                        i <= operation.nbDocument.value;
                                        i++
                                    ) {
                                        const documentName =
                                            operation.code.value + "_V" + i;
                                        const newDocument: CreateDocumentIn = {
                                            name: documentName,
                                            type_uid:
                                                Types.document.types.tract_Uid,
                                        };
                                        const document =
                                            await $swClient.createDocument(
                                                campaign.uid,
                                                newDocument
                                            );

                                        await $swClient.updateDocumentGroup(
                                            document.uid,
                                            "ecat"
                                        );
                                        await $swClient.updateDocumentOrderOption(
                                            document.uid,
                                            ["webcatalog"]
                                        );

                                        // create an init page
                                        let createPageIn: CreatePageIn = {width: 210, height: 297}
                                        let initPage = await $swClient.createPage(campaign.uid, createPageIn)
                                        await $swClient.addPageToDocument(document.uid, initPage.uid)
                                        await $swClient.createPageVersion(initPage.uid)
                                        let sectors = await $swClient.getSectors()
                                        for (let sector of sectors) {
                                            await $swClient.addSectorToPage(initPage.uid, sector.uid)
                                        }

                                        if (operation.nbDocument.value === i) {
                                            $loader.hide(mainProcessId);
                                            $loader.hide(documentsProcessId);
                                            formMode = "end-success";
                                            onCloseToast(formMode);
                                        }
                                    }
                                }
                            }
                        })
                        .catch((err) => {
                            console.error(err);
                            formMode = "end-error";
                            onCloseToast(formMode);
                            $loader.hide(mainProcessId);
                            $loader.hide(campaignProcessId);
                        });
                } else {
                    formMode = "end-error";
                    onCloseToast(formMode);
                    console.error("The operation code already exist");
                    $loader.hide(mainProcessId);
                }
            })
            .catch((err) => {
                console.error(err);
                formMode = "end-error";
                onCloseToast(formMode);
                $loader.hide(mainProcessId);
                $loader.hide(checkProcessId);
            });
    }

    /**
     * come back to the write mode
     */
    function onBack() {
        formMode = "write";
    }

    function isOperationCodeExist(operationcode: string): Promise<boolean> {
        return new Promise((resolve, reject) => {
            $swClient
                .getCampaigns()
                .then((campaigns) => {
                    if (campaigns.length === 0) {
                        resolve(false);
                    }
                    campaigns.forEach((campaign, i) => {
                        campaign.attrs.forEach((attr) => {
                            if (
                                attr.key === Types.campaign.attrs.code &&
                                attr.value === operationcode
                            ) {
                                resolve(true);
                            }
                            if (campaigns.length - 1 === i) {
                                resolve(false);
                            }
                        });
                    });
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    /**
     * Check all inputs in form. Return true if all are valid
     */
    async function checkForm(): Promise<boolean> {
        let errorFound = false;
        operation.code.error = [];
        operation.name.error = [];
        operation.startDate.error = [];
        operation.endDate.error = [];
        operation.displayDate.error = [];
        operation.nbDocument.error = [];
        operation.centrale.error = [];

        const exist = await isOperationCodeExist(operation.code.value);

        if (exist) {
            operation.code.error.push("Ce code opération existe déjà.");
            errorFound = true;
        }
        if (operation.code.value == "") {
            operation.code.error.push("Ce champs est obligatoire.");
            errorFound = true;
        }
        if (operation.name.value == "") {
            operation.name.error.push("Ce champs est obligatoire.");
            errorFound = true;
        }
        if (operation.displayDate.value == "") {
            operation.displayDate.error.push("Ce champs est obligatoire.");
            errorFound = true;
        }
        if (
            !moment(operation.displayDate.value, "YYYY-MM-DD", true).isValid()
        ) {
            operation.displayDate.error.push(
                "La date doit être au format 'aaaa-mm-aa'"
            );
            errorFound = true;
        }
        // if (new Date(operation.displayDate.value).getTime() < new Date(new Date().setHours(0)).getTime()) {
        //     operation.displayDate.error.push("La date doit être supérieur à aujourd'hui.");
        //     errorFound = true;
        // }
        if (operation.startDate.value == "") {
            operation.startDate.error.push("Ce champs est obligatoire.");
            errorFound = true;
        }
        if (!moment(operation.startDate.value, "YYYY-MM-DD", true).isValid()) {
            operation.startDate.error.push(
                "La date doit être au format 'aaaa-mm-aa'"
            );
            errorFound = true;
        }
        if (
            new Date(operation.startDate.value).getTime() <
            new Date(
                new Date(operation.displayDate.value).setHours(0)
            ).getTime()
        ) {
            operation.startDate.error.push(
                "La date doit être supérieur à la date d'affichage."
            );
            errorFound = true;
        }
        if (operation.endDate.value == "") {
            operation.endDate.error.push("Ce champs est obligatoire.");
            errorFound = true;
        }
        if (!moment(operation.endDate.value, "YYYY-MM-DD", true).isValid()) {
            operation.endDate.error.push(
                "La date doit être au format 'aaaa-mm-aa'"
            );
            errorFound = true;
        }
        if (
            new Date(operation.endDate.value).getTime() <
            new Date(new Date(operation.startDate.value).setHours(0)).getTime()
        ) {
            operation.endDate.error.push(
                "La date doit être supérieur à la date de début."
            );
            errorFound = true;
        }
        if (
            operation.nbDocument.value == undefined ||
            operation.nbDocument.value == null ||
            operation.nbDocument.value < 1
        ) {
            operation.nbDocument.error.push(
                "Le nombre de version à créer doit être supérieur ou égal à 1."
            );
            errorFound = true;
        }
        if (
            operation.typeCampaign.value == Types.campaign.types.regional &&
            operation.centrale.value == ""
        ) {
            operation.centrale.error.push("Ce champs est obligatoire.");
            errorFound = true;
        }
        operation.code.error = operation.code.error;
        return !errorFound;
    }
</script>

<div>
    <!-- TITLE -->
    <div id="header">
        <h1>Créer une opération</h1>
    </div>

    <!-- SUCCESS / ERROR MESSAGE -->
    <!-- {#if formMode === "end-success" || formMode === "end-error"}
        <div class="end-msg {formMode}">
            <h1>L'opération a été créée avec succès.</h1>
            <h2>Un problème est survenu lors de la création de l'opération.</h2>
        </div>
    {/if} -->

    <!-- TABLE -->
    {#if formMode === "read" || formMode === "write"}
        <div id="table">
            <!-- ==== OPERATION CODE ==== -->
            <div
                class="line line-beige {operation.code.error.length > 0
                    ? 'line-error'
                    : ''}"
            >
                <div class="col-label">
                    Code
                    {#if formMode === "write"}
                        <span class="require-label">*</span>
                    {/if}
                </div>
                <div class="col-input">
                    {#if formMode === "write"}
                        <input
                            type="text"
                            placeholder="Code de l'opération"
                            bind:value={operation.code.value}
                        />
                    {:else if formMode === "read"}
                        {operation.code.value}
                    {/if}
                </div>
                <div
                    class="col-info"
                    title="Le code de l'opération (ex: 22G202G)."
                >
                    <i class="fas fa-info-circle" />
                </div>
            </div>
            {#if operation.code.error.length > 0}
                <div class="line line-error">
                    <ul>
                        {#each operation.code.error as error}
                            <li>{error}</li>
                        {/each}
                    </ul>
                </div>
            {/if}

            <!-- ==== NAME ==== -->
            <div
                class="line {operation.name.error.length > 0
                    ? 'line-error'
                    : ''}"
            >
                <div class="col-label">
                    Nom
                    {#if formMode === "write"}
                        <span class="require-label">*</span>
                    {/if}
                </div>
                <div class="col-input">
                    {#if formMode === "write"}
                        <input
                            type="text"
                            placeholder="Nom de l'opération"
                            bind:value={operation.name.value}
                        />
                    {:else if formMode === "read"}
                        {operation.name.value}
                    {/if}
                </div>
                <div
                    class="col-info"
                    title="Le nom de l'opération tel qu'il sera affiché."
                >
                    <i class="fas fa-info-circle" />
                </div>
            </div>
            {#if operation.name.error.length > 0}
                <div class="line line-error">
                    <ul>
                        {#each operation.name.error as error}
                            <li>{error}</li>
                        {/each}
                    </ul>
                </div>
            {/if}

            <!-- ==== DISPLAY DATE ==== -->
            <div
                class="line line-beige {operation.displayDate.error.length > 0
                    ? 'line-error'
                    : ''}"
            >
                <div class="col-label">
                    Affichage
                    {#if formMode === "write"}
                        <span class="require-label">*</span>
                    {/if}
                </div>
                <div class="col-input">
                    {#if formMode === "write"}
                        <input
                            type="date"
                            bind:value={operation.displayDate.value}
                        />
                    {:else if formMode === "read"}
                        {new moment(operation.displayDate.value).format(
                            "DD MMMM YYYY"
                        )}
                    {/if}
                </div>
                <div
                    class="col-info"
                    title="La date auquel l'opération sera affiché."
                >
                    <i class="fas fa-info-circle" />
                </div>
            </div>
            {#if operation.displayDate.error.length > 0}
                <div class="line line-error">
                    <ul>
                        {#each operation.displayDate.error as error}
                            <li>{error}</li>
                        {/each}
                    </ul>
                </div>
            {/if}

            <!-- ==== START DATE ==== -->
            <div
                class="line {operation.startDate.error.length > 0
                    ? 'line-error'
                    : ''}"
            >
                <div class="col-label">
                    Début
                    {#if formMode === "write"}
                        <span class="require-label">*</span>
                    {/if}
                </div>
                <div class="col-input">
                    {#if formMode === "write"}
                        <input
                            type="date"
                            bind:value={operation.startDate.value}
                            min={operation.displayDate.value}
                            disabled={!operation.displayDate.value}
                        />
                    {:else if formMode === "read"}
                        {new moment(operation.startDate.value).format(
                            "DD MMMM YYYY"
                        )}
                    {/if}
                </div>
                <div
                    class="col-info"
                    title="La date auquel l'opération commencera."
                >
                    <i class="fas fa-info-circle" />
                </div>
            </div>
            {#if operation.startDate.error.length > 0}
                <div class="line line-error">
                    <ul>
                        {#each operation.startDate.error as error}
                            <li>{error}</li>
                        {/each}
                    </ul>
                </div>
            {/if}

            <!-- ==== END DATE ==== -->
            <div
                class="line line-beige {operation.endDate.error.length > 0
                    ? 'line-error'
                    : ''}"
            >
                <div class="col-label">
                    Fin
                    {#if formMode === "write"}
                        <span class="require-label">*</span>
                    {/if}
                </div>
                <div class="col-input">
                    {#if formMode === "write"}
                        <input
                            type="date"
                            bind:value={operation.endDate.value}
                            min={operation.startDate.value}
                            disabled={!operation.startDate.value}
                        />
                    {:else if formMode === "read"}
                        {new moment(operation.endDate.value).format(
                            "DD MMMM YYYY"
                        )}
                    {/if}
                </div>
                <div
                    class="col-info"
                    title="La date auquel l'opération finira."
                >
                    <i class="fas fa-info-circle" />
                </div>
            </div>
            {#if operation.endDate.error.length > 0}
                <div class="line line-error">
                    <ul>
                        {#each operation.endDate.error as error}
                            <li>{error}</li>
                        {/each}
                    </ul>
                </div>
            {/if}

            <!-- ==== NB DOCUMENT ==== -->
            <div
                class="line {operation.nbDocument.error.length > 0
                    ? 'line-error'
                    : ''}"
            >
                <div class="col-label">
                    Nombre de version
                    {#if formMode === "write"}
                        <span class="require-label">*</span>
                    {/if}
                </div>
                <div class="col-input">
                    {#if formMode === "write"}
                        <input
                            type="number"
                            bind:value={operation.nbDocument.value}
                            min="1"
                        />
                    {:else if formMode === "read"}
                        {operation.nbDocument.value}
                    {/if}
                </div>
                <div
                    class="col-info"
                    title="Le nombre de version qui seront créer avec l'opération. (ex: V1, V2, V3)"
                >
                    <i class="fas fa-info-circle" />
                </div>
            </div>
            {#if operation.nbDocument.error.length > 0}
                <div class="line line-error">
                    <ul>
                        {#each operation.nbDocument.error as error}
                            <li>{error}</li>
                        {/each}
                    </ul>
                </div>
            {/if}

            <!-- ==== CAMPAIGN SHOWPAF ==== -->
            <div
                class="line {operation.show_paf.error.length > 0
                    ? 'line-error'
                    : ''}"
            >
                <div class="col-label">Afficher le feuilletable</div>
                <div class="col-input">
                    {#if formMode === "write"}
                        <select bind:value={operation.show_paf.value}>
                            <option value={true}>oui</option>
                            <option value={false}>non</option>
                        </select>
                    {:else if formMode === "read"}
                        {operation.show_paf.value ? "Oui" : "Non"}
                    {/if}
                </div>
                <div class="col-info" title="Afficher le 'Prêt à feuilleter'">
                    <i class="fas fa-info-circle" />
                </div>
            </div>
            {#if operation.show_paf.error.length > 0}
                <div class="line line-error">
                    <ul>
                        {#each operation.show_paf.error as error}
                            <li>{error}</li>
                        {/each}
                    </ul>
                </div>
            {/if}

            <!-- ==== CAMPAIGN ISPAF ==== -->
            {#if operation.show_paf.value}
                <div
                    class="line line-beige {operation.is_paf.error.length > 0
                        ? 'line-error'
                        : ''}"
                >
                    <div class="col-label">Uniquement le feuilletable</div>
                    <div class="col-input">
                        {#if formMode === "write"}
                            <select bind:value={operation.is_paf.value}>
                                <option value={true}>oui</option>
                                <option value={false}>non</option>
                            </select>
                        {:else if formMode === "read"}
                            {operation.is_paf.value ? "Oui" : "Non"}
                        {/if}
                    </div>
                    <div
                        class="col-info"
                        title="Affiche uniquement le 'Prêt à feuilleter'"
                    >
                        <i class="fas fa-info-circle" />
                    </div>
                </div>
                {#if operation.is_paf.error.length > 0}
                    <div class="line line-error">
                        <ul>
                            {#each operation.is_paf.error as error}
                                <li>{error}</li>
                            {/each}
                        </ul>
                    </div>
                {/if}
            {/if}
        </div>
    {/if}

    <!-- INFO -->
    {#if formMode === "read"}
        <div class="description">
            Veuillez vérifier les informations précédentes puis cliquez sur
            'Valider'.
        </div>
    {/if}

    <!-- BUTTONS -->
    <div id="footer">
        {#if formMode === "write"}
            <button class="button is-dark btn-elpev" on:click={onCreate}>Créer</button>
            <button class="button is-dark btn-elpev" on:click={onClose}>Annuler</button>
        {:else if formMode === "read"}
            <button class="button is-dark btn-elpev" on:click={onValid}>Valider</button>
            <button class="button is-dark btn-elpev" on:click={onBack}>Retour</button>
        {:else if formMode === "end-success" || formMode === "end-error"}
            <button class="button is-dark btn-elpev" on:click={onClose}>Fermer</button>
        {/if}
    </div>
</div>

<style lang="scss">
    @import "../styles/variables";

    #header {
        text-align: center;

        h1 {
            color: $dark-black;
        }
    }

    .end-msg {
        font-weight: bold;
        text-decoration: underline;
        text-align: center;
        padding: 20px;
    }

    .end-success {
        h1 {
            display: inline;
            color: green;
        }

        h2 {
            display: none;
        }
    }

    .end-error {
        h1 {
            display: none;
        }

        h2 {
            display: inline;
            color: red;
        }
    }

    .description {
        background-color: #d5ebff;
        color: $blue;
        border-radius: 10px;
        padding: 10px 15px;
        margin: 5px 0;
    }

    #table {
        width: 100%;

        .line {
            display: flex;
            width: 100%;
            padding: 8px 10px;
            align-items: center;

            .col-label {
                width: 30%;

                .require-label {
                    float: right;
                    color: red;
                    margin-right: 5px;
                }
            }

            .col-input {
                width: 65%;

                input {
                    width: 100%;
                }
            }

            .col-info {
                font-size: 25px;
                text-align: center;
                color: $dark-black;
                margin-left: 8px;
                cursor: help;
            }
        }

        .line-beige {
            background-color: $beige;
        }

        .line-error {
            background-color: #ffc6c6;
            color: darkred;

            ul {
                margin-top: 0;
            }
        }
    }

    #footer {
        margin-top: 10px;
        width: 100%;
        text-align: center;

        button {
            margin: 0 5px;
            width: 150px;
        }
    }
</style>
